<template>
  <div id="app" class="app">
    <Header/>
    <div class="container-fluid main-section">
        <router-view />
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import { mapActions, mapGetters } from 'vuex';
import { watch } from 'vue';

export default {
  name: 'app',
  components: { Footer, Header },
  mounted() {
    // Watch Auth0 loading state - store user data after login
    watch(
      () => this.$auth0.isLoading.value,
      async (newVal, oldVal) => {
        // When Auth0 finishes loading and user is authenticated
        if (oldVal === true && newVal === false && this.$auth0.user.value?.email) {
          const user = this.$auth0.user.value;
          this.storeLoggedInUser(user);
          await this.fetchUserSettings({ id: user.sub, email: user.email });
        }
      }
    );
  },
  computed: {
    ...mapGetters(['userWithSettings']),
  },
  methods: {
    ...mapActions(['storeLoggedInUser', 'fetchUserSettings']),
  }
};
</script>

<style>
.app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.main-section {
    flex: 1;
}
</style>